import axios from "@/api/axios";

class LeadService {
  list(params = {}) {
    return axios.get("/leads", { params });
  }

  create(payload) {
    return axios.post("/leads", payload);
  }

  get(id) {
    return axios.get(`/leads/${id}`);
  }

  update(id, payload) {
    return axios.patch(`/leads/${id}`, payload);
  }

  getUpdates(id, params = {}) {
    return axios.get(`/leads/${id}/updates`, { params });
  }

  addUpdate(id, payload) {
    return axios.post(`/leads/${id}/updates`, payload);
  }
}

export default new LeadService();
